<template>
     <el-col class="upload-legenda"
            :span="24"
            :gutter="20"
          >
            <el-row type="flex" align="middle">
              <el-col
                :lg="2"
                :xl="2"
                :md="4"
                :sm="4"
                :xs="10"
              >
                <el-tag :type="color">{{label}}</el-tag>
              </el-col>
              <el-col
                :lg="22"
                :xl="22"
                :md="20"
                :sm="20"
                :xs="24"
              >
                <label>&nbsp;<b>{{description}}</b></label>
              </el-col>
            </el-row>
          </el-col>
</template>

<script>
export default {
    name: "UploadLegenda",
    props: {
        label: {
            type: String,
            required: true
        },
        description: {
            type:  String,
            required: true
        },
        color: {
            type: String,
            default: () => 'warning'
        }
    }
}
</script>

<style lang="scss" >
.upload-legenda .el-tag {
  width: 90px;
  text-align: center;
}
</style>